module.exports = __webpack_public_path__ + "static/media/Home-T-03.106db09a.png";